import get from "lodash.get";

import AbstractApiActioner from "services/cores/abstractApiActioner";

import NonMovingCarsActionTypes from "./types";
import NonMovingCarsApi from "./api";
import NonMovingCarsUtils from "./utils";

import paths from "routes/paths";

class NonMovingCarsActioner extends AbstractApiActioner {
  missingRequiredFilters(type = "default", filters) {
    if (
      type === "radius" &&
      (!get(filters, "radius") ||
        !get(filters, "duration") ||
        !get(filters, "position") ||
        get(filters, "filters.area.floor_level") === null ||
        get(filters, "filters.area.floor_level") === undefined ||
        get(filters, "radius") <= 0 ||
        get(filters, "duration") <= 0 ||
        get(filters, "position") <= 0)
    ) {
      return true;
    }

    return false;
  }
}

export default new NonMovingCarsActioner(
  "NonMovingCars",
  NonMovingCarsActionTypes,
  NonMovingCarsApi,
  NonMovingCarsUtils,
  {
    paths: {
      default: paths.api.parkStatistics.dataByRadius.nonMovingCars,
      byAreas: paths.api.parkStatistics.dataByAreas.nonMovingCars,
      byRadius: paths.api.parkStatistics.dataByRadius.nonMovingCars,
    },
  }
);
